
(() => {
  class ModalDialog extends HTMLElement {
    connectedCallback() {
      this.classList.add('modal');
      this.box = this.querySelector('.modal__box');
      this.setAttribute('aria-hidden', 'true');
      this.loaded = false;

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-modal-close]') || e.target.hasAttribute('data-modal-overlay')) {
          this.close();
        }
      });
      this.onKeydown = (e) => {
        if (e.key === 'Escape' && window.ThemeUtils.isTopLayer(this.box || this)) this.close();
      };
    }

    get isOpen() { return this.classList.contains('modal--open'); }

    async open(trigger) {
      if (this.isOpen) return;
      this.triggerEl = trigger || null;
      this.classList.add('modal--open');
      this.setAttribute('aria-hidden', 'false');
      window.ThemeUtils.lockScroll();
      document.addEventListener('keydown', this.onKeydown);
      window.ThemeUtils.trapFocus(this.box || this);

      const src = trigger?.dataset.modalSrc || this.dataset.src;
      if (src && !this.loaded) await this.loadContent(src);
    }

    async loadContent(src) {
      const slot = this.querySelector('[data-modal-content]');
      if (!slot) return;
      slot.classList.add('is-loading');
      try {
        const res = await fetch(src);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const fragment = doc.querySelector('[data-modal-extract]') || doc.body;
        slot.innerHTML = fragment.innerHTML;
        this.loaded = !this.hasAttribute('data-always-fresh');
      } catch (e) {
        console.error('[modal] failed to load', src, e);
      } finally {
        slot.classList.remove('is-loading');
      }
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('modal--open');
      this.setAttribute('aria-hidden', 'true');
      window.ThemeUtils.releaseFocus(this.box || this);
      window.ThemeUtils.unlockScroll();
      document.removeEventListener('keydown', this.onKeydown);
      this.triggerEl?.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      if (this.isOpen) {
        window.ThemeUtils.releaseFocus(this.box || this);
        window.ThemeUtils.unlockScroll();
        document.removeEventListener('keydown', this.onKeydown);
      }
    }
  }

  if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-modal-open]');
    if (!btn) return;
    e.preventDefault();
    document.getElementById(btn.dataset.modalOpen)?.open?.(btn);
  });
})();
